import {
    SearchHoliday,
    AddHoliday,
    UpdateHoliday,
    deleteHoliday,
    findHoliday
  } from "@/services/endpoints/holidays";
  
  export default {
    async AddHoliday({ commit }, payload) {
        try {
          let res = await AddHoliday(payload);
          if (res) {
            return res.data;
          } else {
            throw {};
          }
        } catch (err) {
          throw err;
        }
      },
      async SearchHoliday({commit}, payload) {
        try {
            let res = await SearchHoliday(payload);
            if (res.data) {
                //  commit(' SET_HOLIDAYS', res.data.data)
                return res.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async UpdateHoliday({commit}, payload) {
        try {
            let res = await UpdateHoliday(payload.id, payload.payload);
            if (res) {
                return res.data
            }
        } catch (err) {
            throw new Error(err)
        }
    },
    async deleteHoliday({ commit }, payload) {
      try {
          let res = await deleteHoliday(payload.id)
          if(res) {
              return res.data
          }
          else{
              throw {}
          }
      }
      catch (err) {
          throw err
      }
  },
  async findHoliday({ commit, getters }, payload) {
    try {
      let res = await findHoliday(payload);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  };
  